import { request } from '@/utils';

import { FeedRefetchInterval } from '../const';
import { FeedItem, FeedArticleDetail } from '../types';
import { transArticle } from '../utils/list';
import { setQueryFeedDetailInList } from './list';

const FeedDetailUrl = '/feed';

export const fetchFeedsDetail = (currentAddress?: string, feeds?: FeedItem[]) => {
  if (!currentAddress || !feeds?.length) {
    return;
  }

  const currentTime = +new Date();

  const needUpdateItems = feeds.filter(
    x => x.article.updateAt && currentTime - x.article.updateAt >= FeedRefetchInterval,
  );

  needUpdateItems.forEach(x => {
    request
      .get<{ feed: FeedItem }>(FeedDetailUrl, { id: x.article.id })
      .then(({ feed }) => {
        setQueryFeedDetailInList(currentAddress, feed.article.id, (record: FeedArticleDetail) => {
          const newArticle = transArticle(feed.article);
          const {
            // 不用替换的字段拎出来
            id,
            creator,
            creator_id,
            content,
            type,
            images,
            card,
            entities,
            create_at,
            _daytime,
            _fulltime,
            _author,
            ...rest
          } = newArticle;

          Object.assign(record.article, rest);
        });
      })
      .catch(() => null);
  });
};
